/* eslint-disable import/no-unresolved */
import React from 'react';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useImg } from 'hooks';
import { DESKTOP, FROM_TABLET, MOBILE, TABLET, TO_DESKTOP } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Stepper = () => {
  return (
    <ChangeableBackgroundSection
      id="stepper-wrapper-bg"
      defaultStyle={{ backgroundColor: 'transparent' }}
    >
      <Wrapper>
        <StyledContainer isSticky>
          <Title>{useText('stepper__title', true)}</Title>
          <List>
            {[...Array(3)].map((i, idx) => {
              const index = idx + 1;
              return (
                <Item key={index}>
                  <ItemIcon>
                    {useImg(
                      `stepper-icon-${index}.svg`,
                      `stepper__icon_${index}`,
                    )}
                  </ItemIcon>
                  <ItemTitle>
                    {useText(`stepper_item__title_${index}`, true)}
                  </ItemTitle>
                </Item>
              );
            })}
          </List>
        </StyledContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const StyledContainer = styled(Container)`
  @media ${DESKTOP} {
    padding-inline-end: 410px;
  }
`;

const Wrapper = styled.section`
  @media ${DESKTOP} {
    padding: 48px 0;
  }

  @media ${TABLET} {
    padding: 21px 0;
  }

  @media ${MOBILE} {
    padding: 24px 0;
  }
`;

const Title = styled.div`
  margin: 0 auto 41px;
  font-weight: 700;
  font-size: 36px;
  line-height: 44px;
  text-align: center;
  color: #000000;

  @media ${TABLET} {
    font-size: 34px;
    line-height: 42px;
    margin: 0 auto 36px;
  }

  @media ${MOBILE} {
    font-size: 22px;
    line-height: 32px;
    margin: 0 auto 44px;
  }
`;

const List = styled.div`
  counter-reset: stepper;
  position: relative;
  display: flex;
  justify-content: center;

  &:after {
    content: '';
    position: absolute;
    right: 83px;
    top: 39px;
    width: 78%;
    height: 0;
    border-bottom: 9px dotted #D2AFFF;
    z-index: -1;
  }

  @media ${MOBILE} {
    flex-direction: column;

    &:after {
      right: 47px;
      top: 12px;
      bottom: 40px;
      width: 0;
      height: auto;
      border-bottom: none;
      border-right: 9px dotted #00a3e6;
    }
  }
`;

const Item = styled.div`
  counter-increment: stepper;
  position: relative;

  @media ${FROM_TABLET} {
    text-align: center;
    width: 255px;

    &:not(:last-child) {
      margin-inline-end: 30px;
    }
  }

  @media ${MOBILE} {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: 60px;
    }
  }
`;

const ItemIcon = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 86px;
  height: 86px;
  margin: 0 auto 29px;

  @media ${TABLET} {
    margin: 0 auto 25px;
  }

  @media ${MOBILE} {
    margin: 0;
    margin-inline-end: 20px;
    margin-right: 18px;
    width: 66px;
    height: 66px;
  }
`;

const ItemTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  color: #000000;

  @media ${TO_DESKTOP} {
    font-size: 15px;
    line-height: 26px;
  }
`;

export default Stepper;
